import { render, staticRenderFns } from "./FormSelectMany.vue?vue&type=template&id=1f940624&scoped=true"
import script from "./FormSelectMany.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSelectMany.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormSelectMany.vue?vue&type=style&index=0&id=1f940624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f940624",
  null
  
)

export default component.exports